import React, { useEffect, useRef } from 'react'
import ActivitySection from './ActivitySection'
import EssentialActionsSection from './EssentialActionsSection'
import GetCareSection from './GetCareSection/GetCareSection'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../actions'
import { useLocation } from 'react-router'
import Page from '../../common/Page'
import $t from '../../../i18n'
import { capitalizeFirstLetter } from '../../../consts'
import StartClinicIntakeDialog from '../dialogs/StartClinicIntakeDialog'
import Alert from '../../common/Alert'
import MinorHome from '../MinorHome'
import { getIsHmoMember } from '../../../utils/hmoUtils'
import HmoWelcomeDialog from '../dialogs/HmoWelcomeDialog'
import config from '../../../config.json'
import AutoPaySetDialog from '../dialogs/AutoPaySetDialog'

import './Home.css'

const Banner = ({ className, title, subtitle, image }) => (
  <div className={'enrollment-account-status-banner ' + className}>
    <img
      className="left-watercolor"
      src={config.gcpStorageUrl + '/img/banner-watercolor1.png'}
      alt=""
    />
    <img
      className="right-watercolor"
      src={config.gcpStorageUrl + '/img/banner-watercolor2.png'}
      alt=""
    />
    {image && (
      <img
        src={config.gcpStorageUrl + '/img/' + image}
        className="banner-img"
        alt=""
      />
    )}
    <div className="enrollment-account-status-banner-text">
      <div className="title semi-bold">{title}</div>
      <div className="subtitle">{subtitle}</div>
    </div>
  </div>
)

const Home = () => {
  const dispatch = useDispatch()
  const scrollToRef = useRef(null)
  const search = useLocation().search
  const { userDetails } = useSelector(state => state.profile)
  const greetingTitle = $t('profile.welcome')
  const alertMessage = useSelector(state => state.app.alertMessage)
  const isMinorApp = useSelector(state => state.app.isMinorApp)
  const isHmoMember = getIsHmoMember(userDetails)
  const isEnrollmentPaymentDisabled =
    userDetails?.profile_metadata?.is_payment_disabled

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.STORE_SEARCH_URL, { searchUrl: search })
    )
  }, [])

  const getTitle = () =>
    `${greetingTitle}, ${capitalizeFirstLetter(userDetails?.firstName)}`

  if (isMinorApp) return <MinorHome title={getTitle()} />

  return (
    <Page
      className="home-page grey"
      title={getTitle()}
      displayManageFamily
      displayProfile
    >
      <div className="sections left-section">
        <GetCareSection
          onScrollToEndPress={() =>
            scrollToRef?.current?.scrollIntoView({ behavior: 'smooth' })
          }
        />
        {isHmoMember && isEnrollmentPaymentDisabled && userDetails?.isOwner && (
          <Banner
            className="small-screen"
            title={$t('homeScreen.accountStatusBanner.title')}
            subtitle={$t('homeScreen.accountStatusBanner.subtitle')}
          />
        )}
        {!isHmoMember && <ActivitySection forwardedRef={scrollToRef} />}
        {isHmoMember && <EssentialActionsSection />}
      </div>
      <div className="sections right-sections">
        {isHmoMember && isEnrollmentPaymentDisabled && userDetails?.isOwner && (
          <Banner
            className="big-screen"
            title={$t('homeScreen.accountStatusBanner.title')}
            subtitle={$t('homeScreen.accountStatusBanner.subtitle')}
            image="account-status.svg"
          />
        )}
        {!isHmoMember && <EssentialActionsSection />}
        {isHmoMember && <ActivitySection forwardedRef={scrollToRef} />}
      </div>
      <Alert
        title={'Oh no!'}
        shouldDisplay={!!alertMessage}
        onCancel={() => dispatch(Actions.createAction(Actions.CLEAR_ALERT))}
        onOk={() => dispatch(Actions.createAction(Actions.CLEAR_ALERT))}
      >
        {alertMessage}
      </Alert>
      <StartClinicIntakeDialog />
      <HmoWelcomeDialog />
      <AutoPaySetDialog />
    </Page>
  )
}

export default Home
